import React from "react";
import "./Page4.css";
//-----------------------------------------
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//-----------------------------------------
import pagePhoto4 from "../images/pagePhoto4.png";
//-----------------------------------------

function Page4() {
  return (
    <div className="page4_container">
      <div className="page4_bangla">
        “Shopping Cart” Page থেকে আপনার প্রয়োজন মতো Edit করার পর, “Place Order”
        এ Click করে অর্ডার দেওয়া যাবে।
      </div>
      <div className="page4_english">
        After editing “Shopping Cart” Page for quantity and item as required,
        “Place Order” button is to be clicked for placing the order.
      </div>
      <div className="page4_photo_div">
        <img className="page4_photo" src={pagePhoto4} alt="PagePhoto4 Logo" />
      </div>
      {/*--------------go to page-5 (next page) starts-------------*/}
      <NavLink to="/page5" className="goto_next_page" exact>
        <span className="forwardIcon_text">Next</span>
        <ArrowForwardIcon className="next_page_icon" />
      </NavLink>
      {/*--------------go to page-5 (next page) ends-------------*/}
    </div>
  );
}

export default Page4;
